import React from 'react'
import styled from 'styled-components'
import { useAccount } from 'state/account/hooks'
import { Popover } from 'antd'

// import { useAppDispatch } from 'state'
// import { logoutAccount } from 'state/account'
// import history from 'routerHistory'
// import { useUsers } from 'state/users/hooks'

import { FaSignOutAlt } from 'react-icons/fa'

const StyledButton = styled.button`
  color: rgba(0, 0, 0, 0.65);
  align-items: center;
  display: flex;
  text-transform: capitalize;
  justify-content: flex-start;
  width: 100%;
  background: 0;
  border: 0;
  > svg {
    margin-right: 6px;
  }
  cursor: pointer;
`

export default function AccountMenu() {
  const { shortName } = useAccount()
  // const { pic } = useUsers()
  const AVATAR_LOCATION = '/images/avatar.png'

return (

  <Popover
      placement="bottomRight"
      style={{ padding: 0 }}
      content={
        <StyledButton
          onClick={() => {
            // logout()
            localStorage.clear()
            sessionStorage.clear()
            window.location.href='/login'  
          }}
        >
          <FaSignOutAlt />
          <span>Signout</span>
        </StyledButton>
      }
    >
      <div className="account-menu-user-holder">
        <img src={AVATAR_LOCATION} alt={shortName} className="account-menu-user-image" />
        <div className="account-menu-user-name">{shortName}</div>
      </div>
    </Popover>

)  

  /*
  const dispatch = useAppDispatch()

  const logout = useCallback(() => {
    localStorage.clear()
    sessionStorage.clear()
    dispatch(logoutAccount())
    history.push('/')
  }, [dispatch])
*/
/*
  return (
    <Popover
      placement="bottomRight"
      style={{ padding: 0 }}
      content={
        <StyledButton
          onClick={() => {
            // logout()
            localStorage.clear()
            sessionStorage.clear()
            window.location.href='/login'
          }}
        >
          <FaSignOutAlt />
          <span>Signout</span>
        </StyledButton>
      }
    >
      <StyledTrigger>
        <img
          src={AVATAR_LOCATION}
          alt={shortName}
          style={{ width: '36px', marginTop: '-5px', marginRight: '10px', borderRadius: '36px' }}
          className="profilePic"
        />
        <StyledText>Welcome {shortName}</StyledText>
      </StyledTrigger>
    </Popover>
  )
*/
}
